// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"bc72ccc9","39":"c533b964","54":"58b17cdc","190":"ba40142e","243":"3dfebdb6","420":"998c09e3","500":"ab0a0e7e","679":"d55e98a5"}[chunkId] + ".chunk.css";
};